"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButton = exports.CSS = void 0;
exports.view = view;
var tslib_1 = require("tslib");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var icon_1 = require("../icon");
var theme_1 = require("../theme");
var MDL = {
    container: 'mdl-button mdl-button--icon'
};
exports.CSS = {
    container: 'c-Button',
    flip: 'c-Button--flip',
    isSmall: 'c-Button--is-small',
    icon: 'c-Button--icon'
};
var smallSize = theme_1.DefaultTheme.space(6);
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = (_b = {
            userSelect: 'none',
            color: theme_1.DefaultTheme.font.color.supporting
        },
        // Overwrite MDL '!important' so 'a' tag does not default to a text cursor on hover
        _b['&[disabled]:hover'] = {
            cursor: 'default !important'
        },
        _b),
    _a[exports.CSS.flip] = {
        transform: 'translate(-12px,-12px) rotate(-90deg) !important'
    },
    _a[exports.CSS.isSmall] = {
        width: smallSize,
        height: smallSize,
        'min-width': smallSize,
        'min-height': smallSize,
        'font-size': '80%'
    },
    _a[exports.CSS.icon] = {
        'background-color': 'transparent'
    },
    _a));
function view(icon, ctx) {
    if (ctx === void 0) { ctx = {}; }
    var href = ctx.href ? services_1.Services.Route.getRouteURL(ctx.href, ctx.hrefParams) : undefined;
    var extraClassName = ctx.className != null ? ctx.className : '';
    var isMaterialIcon = typeof icon === 'string';
    var title = ctx.title != null ? (0, i18n_1.Translate)(ctx.title, ctx.titleAttrs) : '';
    return (0, mithril_1.m)(ctx.type || 'a', tslib_1.__assign(tslib_1.__assign({ className: "".concat(MDL.container, " ").concat(exports.CSS.container, " ").concat(extraClassName != null ? extraClassName : ''), id: ctx.id }, (ctx.disabled && { disabled: ctx.disabled })), { title: title, href: href, onclick: ctx.disabled ? undefined : ctx.onclick }), isMaterialIcon ? icon_1.Icon.view(icon, { className: exports.CSS.icon + ' ' + (ctx.flip ? exports.CSS.flip : '') }) : icon);
}
exports.ImageButton = { view: view, CSS: exports.CSS };
//# sourceMappingURL=image.button.js.map